import { Component, OnInit, Injector, OnDestroy, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
declare var $: any;

import { MenuService } from '../../core/menu/menu.service';
import { SettingsService } from '../../core/settings/settings.service';
import { Repository } from '../../services/repository'
@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy, AfterViewChecked {

    menuItems: Array<any>;
    router: Router;
    sbclickEvent = 'click.sidebar-toggle';
    $doc: any = null;

    // Chatbot properties
    @ViewChild('chatContainer', { static: false }) private chatContainer: ElementRef;
    private shouldScrollToBottom = true;
    messages: any[] = [];
    newMessage: string = '';
    isTyping: boolean = false;
    isChatOpen: boolean = false;
    currentUser: any;

    // Dragging properties
    private isDragging = false;
    private currentX: number;
    private currentY: number;
    private initialX: number;
    private initialY: number;
    private xOffset = 0;
    private yOffset = 0;
    private dragElement: HTMLElement;

    constructor(
        public menu: MenuService, 
        public settings: SettingsService, 
      public injector: Injector, 
      public repository: Repository,
        private route: ActivatedRoute
    ) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.menuItems = menu.getMenu();
        
        // Add welcome message
        this.addBotMessage('Xin chào! Tôi là trợ lý AI, bạn cần tôi giúp gì không?');
    }

    ngOnInit() {

        this.router = this.injector.get(Router);

        // Load chat history if available
        this.loadChatHistory();

        this.router.events.subscribe((val) => {
            // close any submenu opened when route changes
            this.removeFloatingNav();
            // scroll view to top
            window.scrollTo(0, 0);
            // close sidebar on route change
            this.settings.setLayoutSetting('asideToggled', false);
        });

        // enable sidebar autoclose from extenal clicks
        this.anyClickClose();

        // Initialize drag functionality after view init
        setTimeout(() => this.initializeDrag(), 100);
    }

    ngAfterViewChecked() {
        this.scrollToBottom();
    }

    initializeDrag() {
        this.dragElement = document.querySelector('.chatbot-container') as HTMLElement;
        
        if (this.dragElement) {
            this.dragElement.addEventListener('mousedown', this.dragStart.bind(this));
            document.addEventListener('mousemove', this.drag.bind(this));
            document.addEventListener('mouseup', this.dragEnd.bind(this));

            // Touch events for mobile
            this.dragElement.addEventListener('touchstart', this.dragStart.bind(this), { passive: false });
            document.addEventListener('touchmove', this.drag.bind(this), { passive: false });
            document.addEventListener('touchend', this.dragEnd.bind(this));
        }
    }

    dragStart(e: MouseEvent | TouchEvent) {
        // Only allow dragging from top area (first 40px)
        const target = e.target as HTMLElement;
        const rect = this.dragElement.getBoundingClientRect();
        
        let clientY: number;
        if (e instanceof MouseEvent) {
            clientY = e.clientY;
        } else {
            clientY = e.touches[0].clientY;
        }

        // Check if click is in the drag area (top 40px)
        if (clientY - rect.top > 40) {
            return;
        }

        // Don't drag if clicking on buttons or inputs
        if (target.tagName === 'BUTTON' || target.tagName === 'INPUT' || target.tagName === 'I') {
            return;
        }

        this.isDragging = true;

        if (e instanceof MouseEvent) {
            this.initialX = e.clientX - this.xOffset;
            this.initialY = e.clientY - this.yOffset;
        } else {
            this.initialX = e.touches[0].clientX - this.xOffset;
            this.initialY = e.touches[0].clientY - this.yOffset;
        }

        this.dragElement.style.transition = 'none';
    }

    drag(e: MouseEvent | TouchEvent) {
        if (this.isDragging) {
            e.preventDefault();

            if (e instanceof MouseEvent) {
                this.currentX = e.clientX - this.initialX;
                this.currentY = e.clientY - this.initialY;
            } else {
                this.currentX = e.touches[0].clientX - this.initialX;
                this.currentY = e.touches[0].clientY - this.initialY;
            }

            this.xOffset = this.currentX;
            this.yOffset = this.currentY;

            this.setTranslate(this.currentX, this.currentY, this.dragElement);
        }
    }

    dragEnd(e: MouseEvent | TouchEvent) {
        if (this.isDragging) {
            this.initialX = this.currentX;
            this.initialY = this.currentY;
            this.isDragging = false;

            // Restore transition for smooth animations
            this.dragElement.style.transition = 'height 0.3s ease, opacity 0.3s ease';
        }
    }

    setTranslate(xPos: number, yPos: number, el: HTMLElement) {
        el.style.transform = `translate3d(${xPos}px, ${yPos}px, 0)`;
    }

    loadChatHistory() {
        if (!this.currentUser || !this.currentUser.user_name) {
            return;
        }
        
      this.repository.getRequest('/api/chatai/history?username=' + this.currentUser.user_name)
           .subscribe((response: any) => {
             if (response && response.success && response.data) {
               this.messages = response.data.map(msg => ({
                 text: msg.Content,
                 isUser: msg.IsFromUser,
                 timestamp: new Date(msg.Timestamp)
               }));
             }
           });
    }

    scrollToBottom(): void {
        try {
            if (this.shouldScrollToBottom && this.chatContainer) {
                this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
            }
        } catch (err) { }
    }

    onScroll(): void {
        const element = this.chatContainer.nativeElement;
        const atBottom = element.scrollHeight - element.scrollTop - element.clientHeight < 30;
        this.shouldScrollToBottom = atBottom;
    }

    toggleChat() {
        this.isChatOpen = !this.isChatOpen;
    }

    sendMessage() {
        if (this.newMessage.trim() === '') {
            return;
        }

        this.addUserMessage(this.newMessage);
        const userMessage = this.newMessage;
        this.newMessage = '';
        this.isTyping = true;

        // Call API
         this.repository.postRequest('/api/chatai/ask', {
           text: userMessage,
           username: this.currentUser ? this.currentUser.user_name : '',
           DonViId: this.currentUser ? this.currentUser.id_don_vi : null
         }).subscribe(
           (response: any) => {
             this.isTyping = false;
             if (response && response.UrlForm) {
               this.router.navigate([response.UrlForm]);
             }
             if (response && response.Answer) {
               this.addBotMessage(response.Answer);
             } else {
               this.addBotMessage("Xin lỗi, tôi không hiểu câu hỏi của bạn.");
             }
           },
           (error) => {
             this.isTyping = false;
             this.addBotMessage('Xin lỗi, đã có lỗi xảy ra. Vui lòng thử lại sau.');
           }
         );
    }

    addUserMessage(text: string, timestamp: Date = new Date()) {
        this.shouldScrollToBottom = true;
        this.messages.push({
            text: text,
            isUser: true,
            timestamp: timestamp
        });
    }

    addBotMessage(text: string, timestamp: Date = new Date()) {
        this.shouldScrollToBottom = true;
        this.messages.push({
            text: text,
            isUser: false,
            timestamp: timestamp
        });
    }

    generateBotResponse(userMessage: string) {
        let botResponse = 'Tôi đã nhận được tin nhắn của bạn. Tôi có thể giúp gì thêm không?';

        if (userMessage.toLowerCase().includes('hello') || userMessage.toLowerCase().includes('hi') || userMessage.toLowerCase().includes('chào')) {
            botResponse = 'Xin chào! Tôi có thể giúp gì cho bạn hôm nay?';
        } else if (userMessage.toLowerCase().includes('help') || userMessage.toLowerCase().includes('giúp')) {
            botResponse = 'Tôi có thể hỗ trợ bạn về thông tin hệ thống, hướng dẫn sử dụng, hoặc trả lời các câu hỏi. Bạn cần hỗ trợ về vấn đề gì?';
        } else if (userMessage.toLowerCase().includes('cảm ơn') || userMessage.toLowerCase().includes('thank')) {
            botResponse = 'Rất vui được giúp đỡ bạn! Nếu cần gì thêm, hãy hỏi tôi nhé.';
        }

        this.addBotMessage(botResponse);
    }

    clearChatHistory() {
        if (confirm('Bạn có chắc chắn muốn xóa tất cả tin nhắn chat?')) {
            this.messages = [];
            
            if (this.currentUser && this.currentUser.user_name) {
                this.repository.postRequest('/api/chatai/clearhistory', { 
                    username: this.currentUser.user_name 
                }).subscribe(
                    (response: any) => {
                        this.addBotMessage('Lịch sử chat đã được xóa. Tôi là trợ lý AI, bạn cần tôi giúp gì không?');
                    },
                    (error) => {
                        this.addBotMessage('Có lỗi xảy ra khi xóa lịch sử chat.');
                    }
                );
            } else {
                this.addBotMessage('Lịch sử chat đã được xóa. Tôi là trợ lý AI, bạn cần tôi giúp gì không?');
            }
        }
    }

    anyClickClose() {
        this.$doc = $(document).on(this.sbclickEvent, (e) => {
            if (!$(e.target).parents('.aside-container').length) {
                this.settings.setLayoutSetting('asideToggled', false);
            } 
        });
    }

    ngOnDestroy() {
        if (this.$doc)
            this.$doc.off(this.sbclickEvent);

        // Clean up drag event listeners
        if (this.dragElement) {
            this.dragElement.removeEventListener('mousedown', this.dragStart.bind(this));
            this.dragElement.removeEventListener('touchstart', this.dragStart.bind(this));
            document.removeEventListener('mousemove', this.drag.bind(this));
            document.removeEventListener('touchmove', this.drag.bind(this));
            document.removeEventListener('mouseup', this.dragEnd.bind(this));
            document.removeEventListener('touchend', this.dragEnd.bind(this));
        }
    }

    toggleSubmenuClick(event) {

        event.preventDefault();

        if (!this.isSidebarCollapsed() && !this.isSidebarCollapsedText() && !this.isEnabledHover()) {

            let ul = $(event.currentTarget.nextElementSibling);

            // hide other submenus
            let parentNav = ul.parents('.sidebar-subnav');
            $('.sidebar-subnav').each((idx, el) => {
                let $el = $(el);
                // if element is not a parent or self ul
                if (el !== parentNav[0] && el !== ul[0]) {
                    this.closeMenu($el);
                }
            });

            // abort if not UL to process
            if (!ul.length) {
                return;
            }

            // any child menu should start closed
            ul.find('.sidebar-subnav').each((idx, el) => {
                this.closeMenu($(el));
            });

            // toggle UL height
            const ulHeight = ul.css('height')
            if (ulHeight === 'auto' || parseInt(ulHeight, 10)) {
                this.closeMenu(ul);
            }
            else {
                // expand menu
                ul.on('transitionend', () => {
                    ul.css('height', 'auto').off('transitionend');
                }).css('height', ul[0].scrollHeight);
                // add class to manage animation
                ul.addClass('opening');
            }

        }

    }

    // Close menu collapsing height
    closeMenu(elem) {
        elem.css('height', elem[0].scrollHeight); // set height
        elem.css('height', 0); // and move to zero to collapse
        elem.removeClass('opening');
    }

    toggleSubmenuHover(event) {
        let self = this;
        if (this.isSidebarCollapsed() || this.isSidebarCollapsedText() || this.isEnabledHover()) {
            event.preventDefault();

            this.removeFloatingNav();

            let ul = $(event.currentTarget.nextElementSibling);
            let anchor = $(event.currentTarget);

            if (!ul.length) {
                return; // if not submenu return
            }

            let $aside = $('.aside-container');
            let $asideInner = $aside.children('.aside-inner'); // for top offset calculation
            let $sidebar = $asideInner.children('.sidebar');
            let mar = parseInt($asideInner.css('padding-top'), 0) + parseInt($aside.css('padding-top'), 0);
            let itemTop = ((anchor.parent().position().top) + mar) - $sidebar.scrollTop();

            let floatingNav = ul.clone().appendTo($aside);
            let vwHeight = document.body.clientHeight;

            // let itemTop = anchor.position().top || anchor.offset().top;

            floatingNav
                .addClass('nav-floating')

            // each item has ~40px height
            // multiply to force space for at least N items
            var safeOffsetValue = (40 * 5)
            var navHeight = floatingNav.height() + 2; // 2px border
            var safeOffset = navHeight < safeOffsetValue ? navHeight : safeOffsetValue;

            var displacement = 25; // displacement in px from bottom

            // if not enough space to show N items, use then calculated 'safeOffset'
            var menuTop = (vwHeight - itemTop > safeOffset) ? itemTop : (vwHeight - safeOffset - displacement);

            floatingNav
                .removeClass('opening') // necesary for demo if switched between normal//collapsed mode
                .css({
                    position: this.settings.getLayoutSetting('isFixed') ? 'fixed' : 'absolute',
                    top: menuTop,
                    bottom: (floatingNav.outerHeight(true) + menuTop > vwHeight) ? (displacement+'px') : 'auto'
                });

            floatingNav
                .on('mouseleave', () => { floatingNav.remove(); })
                .find('a').on('click', function(e) {
                    e.preventDefault(); // prevents page reload on click
                    // get the exact route path to navigate
                    let routeTo = $(this).attr('route');
                    if (routeTo) self.router.navigate([routeTo]);
                });

            this.listenForExternalClicks();

        }

    }

    listenForExternalClicks() {
        let $doc = $(document).on('click.sidebar', (e) => {
            if (!$(e.target).parents('.aside-container').length) {
                this.removeFloatingNav();
                $doc.off('click.sidebar');
            }
        });
    }

    removeFloatingNav() {
        $('.nav-floating').remove();
    }

    isSidebarCollapsed() {
        return this.settings.getLayoutSetting('isCollapsed');
    }
    isSidebarCollapsedText() {
        return this.settings.getLayoutSetting('isCollapsedText');
    }
    isEnabledHover() {
        return this.settings.getLayoutSetting('asideHover');
    }
}
